module.exports = __webpack_public_path__ + "static/media/picture-(39).7fb37468.JPG";